<template>
  <div class="popup_overlay px-4">
    <div
      class="custom_dialog rounded-xl"
      id="employeedialog"
      style="width: 600px; max-height: 85%; overflow: auto"
    >
      <div class="relative bg-white">
        <div class="bg-primary flex justify-between p-3 sticky top-0">
          <div class="font-medium text-white heading-3">Select Employee</div>
        </div>
        <div style="white-space: nowrap" class="mb-4 mt-2">
          <div
            v-for="(employee, index) in employeeList"
            :key="`employee-${index}-${employee.selected}`"
            class="cust_card mx-2 heading-3 border-b border-gray1 bg-white text-sm px-3 py-3 items-center hover:bg-gray1 cursor-pointer"
            @click="toggleEmployeeSelection(index)"
          >
            <div class="flex items-center gap-3">
              <span class="flex items-center justify-center" style="width: 20px;">
                <i v-if="employee.selected" class="fas fa-check-circle text-primary"></i>
                <i v-else class="fa-regular fa-circle text-gray-400"></i>
              </span>
              <div class="flex-1">
                <p class="text-gray4 heading-5" style="font-weight: bold">
                  {{ employee.fullName }}
                </p>
                <p class="text-primary heading-7" style="font-size: 0.75rem">
                  {{ getJobCountText(employee.jobCount) }}
                </p>
              </div>
            </div>
          </div>
          <div class="bg-white w-full flex justify-end pr-3 pt-3">
            <div class="text-rigth flex gap-2 mb-3">
              <Button
                :btnSize="'medium'"
                :textColor="'text1'"
                :btnColor="'gray1'"
                :btnText="'Cancel'"
                @buttonAction="discard()"
              />
              <Button
                :btnSize="'medium'"
                :textColor="'white'"
                :btnColor="'success'"
                :btnText="'Add'"
                @buttonAction="saveEmployeeSelection()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/View/components/globalButton.vue";

export default {
  props: {
    employees: {
      type: Array,
      default: () => []
    },
    selectedEmployees: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Button
  },
  data() {
    return {
      employeeList: []
    };
  },
  mounted() {
    this.employeeList = [...this.employees];

    // Mark pre-selected employees as selected
    if (this.selectedEmployees && this.selectedEmployees.length > 0) {
      this.selectedEmployees.forEach(selectedEmp => {
        const index = this.employeeList.findIndex(
          emp => emp.userDetailId === selectedEmp.userDetailId
        );
        if (index !== -1) {
          this.employeeList[index].selected = true;
        }
      });
    }
  },
  methods: {
    toggleEmployeeSelection(index) {
      this.employeeList[index].selected = !this.employeeList[index].selected;
      this.$forceUpdate();
    },
    getJobCountText(jobCount) {
      if (jobCount === 1) {
        return "1 job is open";
      } else if (jobCount > 1) {
        return `${jobCount} jobs are open`;
      } else {
        return "No jobs assigned";
      }
    },
    discard() {
      document.body.style = "overflow: visible;";
      this.$emit("selectEmployeeHandler", null);
    },
    saveEmployeeSelection() {
      let selectedList = [];
      this.employeeList.forEach(employee => {
        if (employee.selected) {
          selectedList.push({
            userDetailId: employee.userDetailId,
            firstName: employee.firstName,
            lastName: employee.lastName,
            fullName: employee.fullName,
            jobCount: employee.jobCount
          });
        }
      });
      this.$emit('selectEmployeeHandler', selectedList);
    }
  }
};
</script>

<style scoped>
</style>
